import { observable, action } from 'mobx';
import json from '../../assets/data.json';

export class Store {
	@observable loading = true;
	@observable layer = '';
	@observable point = '';
	@observable popup = '';
	@observable points = json;
	
	// by default the loading will be set to true
	// load all the map layers
	// when done, hide loaders and render content
	preloadImages() {
		let urls = [];

		if (window.innerWidth >= 992) {
			urls = [
				'/city/assets/map-base.jpg',
				'/city/assets/map-potable.jpg',
				'/city/assets/map-sensus.jpg',
				'/city/assets/map-zenner.jpg',
				'/city/assets/map-smart.jpg',
				'/city/assets/map-smartz.jpg',
				'/city/assets/map-stormwater.jpg',
				'/city/assets/map-wastewater.jpg'
			];
		} else {
			urls = [
				'/city/assets/map-base-sm.jpg',
				'/city/assets/map-potable-sm.jpg',
				'/city/assets/map-sensus-sm.jpg',
				'/city/assets/map-zenner-sm.jpg',
				'/city/assets/map-smart-sm.jpg',
				'/city/assets/map-smartz-sm.jpg',
				'/city/assets/map-stormwater-sm.jpg',
				'/city/assets/map-wastewater-sm.jpg'
			];
		}

		const promies = [];

		urls.forEach((url) => {
			const p = new Promise((resolve, reject) => {
				const img = new Image();
				img.src = url;
				img.onload = resolve;
			});
			promies.push(p);
		});

		Promise.all(promies).then(() => {
			// if (location.hostname == "localhost" || location.hostname.includes("192.168")) {
			//   //!! FOR DEVELOPMENT ONLY
			//   $("body").addClass("loaded");
			//   this.loading = false;
			// } else {
			setTimeout(() => {
				$('body').addClass('loaded');
				this.loading = false;
				// ga('send', 'event', 'LB City', 'Map', 'Loaded');
				dataLayer.push({
					'event': 'gaEvent',
					'eventCategory': 'LB City',
					'eventAction': 'Loaded',
					'eventLabel': 'Map'
				  });
			}, 2500);
			// }
		});
	}

	@action
	setLayer(layer) {
		if (!layer) return;
		$('body').addClass('layer-activated');
		this.layer = layer;
	}

	@action
	removeLayer() {
		$('body').removeClass('layer-activated');
		this.layer = null;
	}
}

export default new Store();
